import 'antd/lib/date-picker/style';
import 'antd/lib/icon/style';

import '../common.less';
import '../VtxYearPicker.less'